/**
 * @prettier
 */
import type { AppVm } from 'src/types/StateVm';
import { createPaymentDistribution } from 'src/utils/payment/createPaymentDistribution';
import { requireValue } from 'src/utils/require/requireValue';

export function refreshPaymentState(app: AppVm): void {
    if (!app.cartItems.length || !app.restaurant) {
        delete app.payment;
        return;
    }

    const payment = createPaymentDistribution({
        restaurantId: requireValue(app.restaurant).restaurantId,
        credits: app.credits,
        gifts: app.gifts,
        promoCode: app.promoCode,
        orderType: app.orderType,
        paymentMethod: app.paymentMethod,
        pickupTime: app.pickupTime,
        orderItems: app.cartItems,
        restaurantTimeZone: requireValue(app.restaurant).timeZone,
        deliveryEstimate: app.deliveryEstimate,
        useLetsEatCredits: app.useLetsEatCredits,
        driverTip: app.driverTip,
        addTaxToTotalEnabled: requireValue(app.restaurant).addTaxToTotalEnabled,
        taxRate: requireValue(app.restaurant).taxRate,
    });

    const usableLetsEatCredits = createPaymentDistribution({
        restaurantId: requireValue(app.restaurant).restaurantId,
        credits: app.credits,
        gifts: app.gifts,
        promoCode: app.promoCode,
        orderType: app.orderType,
        paymentMethod: app.paymentMethod,
        pickupTime: app.pickupTime,
        orderItems: app.cartItems,
        restaurantTimeZone: requireValue(app.restaurant).timeZone,
        deliveryEstimate: app.deliveryEstimate,
        useLetsEatCredits: true,
        addTaxToTotalEnabled: requireValue(app.restaurant).addTaxToTotalEnabled,
        taxRate: requireValue(app.restaurant).taxRate,
    }).usedLetsEatCredits;

    app.payment = {
        subtotal: payment.subtotal,
        subtotalAfterDiscount: payment.subtotalAfterDiscount,
        customerDeliveryCost: payment.customerDeliveryCost,
        productDiscount: payment.productDiscount,
        tax: payment.tax,
        taxRate: payment.taxRate,
        promoCodeSubtotal: payment.promoCodeSubtotal,
        promoCodeDiscount: payment.promoCodeDiscount,
        promoCodeCredits: payment.promoCodeCredits,
        usableLetsEatCredits,
        usedCredits: payment.usedCredits,
        letsEatCredits: payment.usedLetsEatCredits,
        companyCredits: payment.usedCompanyCredits,
        total: payment.total,
    };
}
